var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-apex-charts',{attrs:{"type":"bar","height":"400","options":_vm.apexChatData.columnChart.chartOptions,"series":_vm.apexChatData.columnChart.series}})
}
var staticRenderFns = []

export { render, staticRenderFns }